var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    {
      staticClass: "card-languages",
      style: { marginTop: !_vm.isConfigMode ? "10vh" : "" },
      attrs: { right: "" },
    },
    [
      _c(
        "v-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$t("message.Cambia_lingua")) + " "),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close-menu-language")
                },
              },
            },
            [_c("v-icon", [_vm._v("close")])],
            1
          ),
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card-text",
        [
          _c(
            "v-list",
            [
              _c(
                "v-list-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.changeLanguage("IT")
                    },
                  },
                },
                [
                  _vm.$i18n.locale == "IT"
                    ? _c(
                        "v-icon",
                        { staticClass: "mr-2", attrs: { color: "primary" } },
                        [_vm._v("check")]
                      )
                    : _vm._e(),
                  _c("v-list-item-avatar", { staticClass: "mr-2" }, [
                    _c("img", {
                      attrs: {
                        src: "https://thema-optical.com/images/flags/IT.png",
                        alt: "Italiano",
                      },
                    }),
                  ]),
                  _c("v-list-item-content", [
                    _vm._v(" " + _vm._s(_vm.$t("message.Italiano")) + " "),
                  ]),
                ],
                1
              ),
              _c("v-divider", { staticClass: "mt-2 mb-2" }),
              _c(
                "v-list-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.changeLanguage("DE")
                    },
                  },
                },
                [
                  _vm.$i18n.locale == "DE"
                    ? _c(
                        "v-icon",
                        { staticClass: "mr-2", attrs: { color: "primary" } },
                        [_vm._v("check")]
                      )
                    : _vm._e(),
                  _c("v-list-item-avatar", { staticClass: "mr-2" }, [
                    _c("img", {
                      attrs: {
                        src: "https://thema-optical.com/images/flags/DE.png",
                        alt: "Tedesco",
                      },
                    }),
                  ]),
                  _c("v-list-item-content", [
                    _vm._v(" " + _vm._s(_vm.$t("message.Tedesco")) + " "),
                  ]),
                ],
                1
              ),
              _c("v-divider", { staticClass: "mt-2 mb-2" }),
              _c(
                "v-list-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.changeLanguage("ES")
                    },
                  },
                },
                [
                  _vm.$i18n.locale == "ES"
                    ? _c(
                        "v-icon",
                        { staticClass: "mr-2", attrs: { color: "primary" } },
                        [_vm._v("check")]
                      )
                    : _vm._e(),
                  _c("v-list-item-avatar", { staticClass: "mr-2" }, [
                    _c("img", {
                      attrs: {
                        src: "https://thema-optical.com/images/flags/ES.png",
                        alt: "Spagnolo",
                      },
                    }),
                  ]),
                  _c("v-list-item-content", [
                    _vm._v(" " + _vm._s(_vm.$t("message.Spagnolo")) + " "),
                  ]),
                ],
                1
              ),
              _c("v-divider", { staticClass: "mt-2 mb-2" }),
              _c(
                "v-list-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.changeLanguage("FR")
                    },
                  },
                },
                [
                  _vm.$i18n.locale == "FR"
                    ? _c(
                        "v-icon",
                        { staticClass: "mr-2", attrs: { color: "primary" } },
                        [_vm._v("check")]
                      )
                    : _vm._e(),
                  _c("v-list-item-avatar", { staticClass: "mr-2" }, [
                    _c("img", {
                      attrs: {
                        src: "https://thema-optical.com/images/flags/FR.png",
                        alt: "Francese",
                      },
                    }),
                  ]),
                  _c("v-list-item-content", [
                    _vm._v(" " + _vm._s(_vm.$t("message.Francese")) + " "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-divider", { staticClass: "mt-2 mb-2" }),
          _c(
            "v-list-item",
            {
              on: {
                click: function ($event) {
                  return _vm.changeLanguage("EN")
                },
              },
            },
            [
              _vm.$i18n.locale == "EN"
                ? _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { color: "primary" } },
                    [_vm._v("check")]
                  )
                : _vm._e(),
              _c("v-list-item-avatar", { staticClass: "mr-2" }, [
                _c("img", {
                  attrs: {
                    src: "https://thema-optical.com/images/flags/EN.png",
                    alt: "Inglese",
                  },
                }),
              ]),
              _c("v-list-item-content", [
                _vm._v(" " + _vm._s(_vm.$t("message.Inglese")) + " "),
              ]),
            ],
            1
          ),
          _c("v-divider", { staticClass: "mt-2 mb-2" }),
          _c(
            "v-list-item",
            {
              on: {
                click: function ($event) {
                  return _vm.changeLanguage("US")
                },
              },
            },
            [
              _vm.$i18n.locale == "US"
                ? _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { color: "primary" } },
                    [_vm._v("check")]
                  )
                : _vm._e(),
              _c("v-list-item-avatar", { staticClass: "mr-2" }, [
                _c("img", {
                  attrs: {
                    src: "https://thema-optical.com/images/flags/US.png",
                    alt: "Americano",
                  },
                }),
              ]),
              _c("v-list-item-content", [
                _vm._v(" " + _vm._s(_vm.$t("message.Americano")) + " "),
              ]),
            ],
            1
          ),
          _c("v-divider", { staticClass: "mt-2 mb-2" }),
          _c(
            "v-list-item",
            {
              on: {
                click: function ($event) {
                  return _vm.changeLanguage("PT")
                },
              },
            },
            [
              _vm.$i18n.locale == "PT"
                ? _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { color: "primary" } },
                    [_vm._v("check")]
                  )
                : _vm._e(),
              _c("v-list-item-avatar", { staticClass: "mr-2" }, [
                _c("img", {
                  attrs: {
                    src: "https://thema-optical.com/images/flags/PT.png",
                    alt: "Portoghese",
                  },
                }),
              ]),
              _c("v-list-item-content", [
                _vm._v(" " + _vm._s(_vm.$t("message.Portoghese")) + " "),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }